import { useTranslation } from 'react-i18next';
import truImg from '../../Assets/Images/solutions-true.svg';
import wastImg from '../../Assets/Images/waste_solutions.png';
import { useSelector } from 'react-redux';

export default function WasteManagement() {
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.lang);
  const cards = t('solutions.waste.cards', { returnObjects: true });
  return (
    <div className="solutions__management" dir="rtl">
      <div className="solutions__management-cards" style={{ order: 2 }}>
        {cards.map((card, index) => (
          <div
            key={index}
            className="solutions__management-cards--item"
            dir={language === 'ar' ? 'rtl' : 'ltr'}
          >
            <img src={truImg} alt={`${card.title}`} loading="lazy" />
            <div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="solutions__management-img" style={{ order: 1 }}>
        <img src={wastImg} alt="waste managemnet" loading="lazy" />
        <p>{t('solutions.waste.paragraph')}</p>
      </div>
    </div>
  );
}
